import { ResponseData } from '../constants/AppUser';
import { createScientificNursingCarePromotionAPIInstance } from '../api/ScientificNursingCarePromotionAPI';
import { DisplayPayload } from '../constants/UserListField';
import * as ScientificNursingCarePromotionConst from '../constants/ScientificNursingCarePromotion';

const scientificNursingCarePromotionAPIInstance = createScientificNursingCarePromotionAPIInstance();
const scientificNursingCarePromotionAPIErrorAction = {
  type: 'SCIENTIFIC_NURSING_CARE_PROMOTION_API_ERROR',
  error: 'APIインスタンスの取得に失敗しました',
};

/**
 * 科学的介護推進・指定月のデータを取得.
 *
 * @param {ResponseData[]} uniqueIds
 * @param {string} month
 * @returns
 */
export const getScientificNursingCarePromotionRecordByMonth = (uniqueIds: ResponseData[], month: string) => {
  return !scientificNursingCarePromotionAPIInstance
    ? scientificNursingCarePromotionAPIErrorAction
    : scientificNursingCarePromotionAPIInstance.getRecordByMonthAPI(uniqueIds, month);
};

/**
 * 科学的介護推進・最新の評価日を取得.
 *
 * @param {string} userId
 * @param {Function} addDisplayDate
 * @param {number} intervalTimeMs
 * @returns
 */
export const getScientificNursingCarePromotionLastDate = (
  userId: string,
  addDisplayDate: (payload: DisplayPayload) => void,
  intervalTimeMs = 500,
) => {
  return async (dispatch: any) => {
    try {
      if (!scientificNursingCarePromotionAPIInstance) {
        return scientificNursingCarePromotionAPIErrorAction;
      }

      // JWT tokenを設定
      await scientificNursingCarePromotionAPIInstance.setAxiosInstanceWithJwtToken();

      // 評価データを取得
      const response = await scientificNursingCarePromotionAPIInstance.getEvaluationsFunc(userId);
      const evaluations = response.data.data || [];

      // 最新の評価日を取得
      let latestDate = '';
      if (evaluations && evaluations.length > 0) {
        // 評価日でソート
        const sortedEvaluations = evaluations.sort((a: any, b: any) => {
          const dateA = `${a.evaluate_date_year}-${a.evaluate_date_month}-${a.evaluate_date_day}`;
          const dateB = `${b.evaluate_date_year}-${b.evaluate_date_month}-${b.evaluate_date_day}`;
          return new Date(dateB).getTime() - new Date(dateA).getTime();
        });

        // 最新の評価日を取得
        const latest = sortedEvaluations[0];
        if (latest) {
          latestDate = `${latest.evaluate_date_year}/${latest.evaluate_date_month}/${latest.evaluate_date_day}`;
        }
      }
      // 評価データがない場合は空文字を設定（ローディングを止める）

      // 表示用の日付を設定
      addDisplayDate({
        user_id: userId,
        displayDate: latestDate,
      });

      dispatch({
        type: ScientificNursingCarePromotionConst.FINISH,
        result: { LoadedCount: 1 },
      });

      return {
        type: 'SCIENTIFIC_NURSING_CARE_PROMOTION_LAST_DATE_SUCCESS',
        result: latestDate,
      };
    } catch (error) {
      console.error('Error fetching scientific nursing care promotion last date:', error);
      // エラーが発生した場合でも、ローディングを止めるために空の日付を設定
      addDisplayDate({
        user_id: userId,
        displayDate: '',
      });
      dispatch({
        type: ScientificNursingCarePromotionConst.FINISH,
        result: { LoadedCount: 1 },
      });
      return {
        type: 'SCIENTIFIC_NURSING_CARE_PROMOTION_LAST_DATE_ERROR',
        error,
      };
    }
  };
};

// アクションの型定義
export interface ScientificNursingCarePromotionAction {
  type: string;
  result?: any;
  error?: any;
}
